import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { dataGridPremiumColumns } from '../../../utils/helper';
import biService from '../../../service/bi.service';
import { BiReportTypeList } from '../../../config/bi_report';

const BiQueryTable = ({ values, dataset, refetchState }) => {
  const { refetch, setRefetch } = refetchState;
  const navigate = useNavigate();
  const { setSelectedValues } = values;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const initialState = {
    filter: {
      filterModel: {
        items: [],
        logicOperator: 'and',
      },
    },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getList = (gridState) => {
    biService.getBiReports(gridState).then((data) => {
      setReports(data);
      setRefetch(false);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      type: 'string',
      headerName: 'Név',
    },
    {
      field: 'biHeadId',
      type: 'singleSelect',
      headerName: 'Forrás',
      valueOptions: dataset.biHeads,
      renderCell: (params) => {
        return params.row.biHead?.name;
      },
    },
    {
      field: 'reportType',
      type: 'singleSelect',
      headerName: 'Típus',
      valueOptions: BiReportTypeList,
      renderCell: (params) => {
        const findedReportType = BiReportTypeList.find((rt) => rt.value === params.row.reportType);
        return findedReportType?.label ?? '';
      },
    },
  ]);

  return (
    <div className="flex overflow-hidden m-4">
      <div className="h-full w-full overflow-x-auto">
        <div className="flex justify-end mx-2">
          <div className="w-full max-w-[180px] relative">
            <ButtonUI
              className="bg-primary w-100 w-full mt-2"
              text="Új"
              type="button"
              onClick={() => {
                navigate('/app/bi/editor');
              }}
            />
          </div>
        </div>

        <div className="inline-block w-full border-b border-gray-200 align-middle mt-4 overflow-y-auto overflow-x-auto">
          <DatagridPremiumUi
            datagridIdentifier={DataGridIdentifiers.biReport}
            datagridInitialState={initialState}
            dataLoader={getList}
            rows={reports.rows}
            height
            refetch={{ refetchTable: refetch, setRefetchTable: setRefetch }}
            rowCount={reports.rowCount}
            columns={columns}
            onRowClick={(rowData) => {
              setSelectedValues(rowData.row);
            }}
            paginationAndfilterMode="server"
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            height={740}
          />
        </div>
      </div>
    </div>
  );
};

export default BiQueryTable;
